import { borders } from '@/config/theme/borders.ts';

export const variables = {
  // box-shadows
  arrowOutline: '0 2px 7px 0 rgba(162, 170, 173, 0.4)',
  basicTransition: 'all .2s ease-in-out',
  boxShadowLabel: '0 5px 23px 0 #d0d3d4',
  boxShadowMenu: '0 3px 24px 0 rgba(208, 211, 212, 0.4)',
  boxShadowTableHead: '0 1px 15px 0 #d0d3d4',
  divider: '0 3px 24px 0 rgba(208, 211, 212, 0.4)',
  ...borders,
};
